export namespace HistoryConstants {
  export const usedPlace = ["", 'Fast Lane', 'SOUTH LOUNGE', 'ITMラウンジ', 'UKBラウンジ', 'KIX Lounge Kansai'];
  export const flightClass = [
    "",
    'エコノミークラス',
    'プレミアムエコノミークラス',
    'ビジネスクラス',
    'ファーストクラス'
  ];
  export const useLounge = [
    "",
    'ラウンジオーサカ',
    'ラウンジ神戸',
    'SOUTH LOUNGE',
    'KIX Lounge Kansai'
  ]
}
